export default __webpack_public_path__ + "static/media/laundry1-beforeA-768w.18720760.png";